/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getInterview = /* GraphQL */ `
  query GetInterview($treatmentConsultationSeq: String!) {
    getInterview(treatmentConsultationSeq: $treatmentConsultationSeq) {
      id
      treatmentConsultationSeq
      userId
      treatmentSerialNumber
      userInfo
      riskOfSerious
      interview
      travelHistory
      intensiveContact
      statusCode
      createdMonth
      createdAt
      recordTime
      recordConsultation
      recordAssessment
      recordPlan
      covidCertificatePath
      updatedAt
    }
  }
`;
export const listInterviews = /* GraphQL */ `
  query ListInterviews(
    $treatmentConsultationSeq: String
    $filter: ModelInterviewFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listInterviews(
      treatmentConsultationSeq: $treatmentConsultationSeq
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        treatmentConsultationSeq
        userId
        treatmentSerialNumber
        userInfo
        riskOfSerious
        interview
        travelHistory
        intensiveContact
        statusCode
        createdMonth
        createdAt
        recordTime
        recordConsultation
        recordAssessment
        recordPlan
        covidCertificatePath
        updatedAt
      }
      nextToken
    }
  }
`;
export const interviewsById = /* GraphQL */ `
  query InterviewsById(
    $id: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelInterviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    interviewsById(
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        treatmentConsultationSeq
        userId
        treatmentSerialNumber
        userInfo
        riskOfSerious
        interview
        travelHistory
        intensiveContact
        statusCode
        createdMonth
        createdAt
        recordTime
        recordConsultation
        recordAssessment
        recordPlan
        covidCertificatePath
        updatedAt
      }
      nextToken
    }
  }
`;
export const interviewsByUserId = /* GraphQL */ `
  query InterviewsByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelInterviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    interviewsByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        treatmentConsultationSeq
        userId
        treatmentSerialNumber
        userInfo
        riskOfSerious
        interview
        travelHistory
        intensiveContact
        statusCode
        createdMonth
        createdAt
        recordTime
        recordConsultation
        recordAssessment
        recordPlan
        covidCertificatePath
        updatedAt
      }
      nextToken
    }
  }
`;
export const interviewsByTreatmentSerialNumber = /* GraphQL */ `
  query InterviewsByTreatmentSerialNumber(
    $treatmentSerialNumber: String!
    $sortDirection: ModelSortDirection
    $filter: ModelInterviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    interviewsByTreatmentSerialNumber(
      treatmentSerialNumber: $treatmentSerialNumber
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        treatmentConsultationSeq
        userId
        treatmentSerialNumber
        userInfo
        riskOfSerious
        interview
        travelHistory
        intensiveContact
        statusCode
        createdMonth
        createdAt
        recordTime
        recordConsultation
        recordAssessment
        recordPlan
        covidCertificatePath
        updatedAt
      }
      nextToken
    }
  }
`;
export const byCreatedMonth = /* GraphQL */ `
  query ByCreatedMonth(
    $createdMonth: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInterviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byCreatedMonth(
      createdMonth: $createdMonth
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        treatmentConsultationSeq
        userId
        treatmentSerialNumber
        userInfo
        riskOfSerious
        interview
        travelHistory
        intensiveContact
        statusCode
        createdMonth
        createdAt
        recordTime
        recordConsultation
        recordAssessment
        recordPlan
        covidCertificatePath
        updatedAt
      }
      nextToken
    }
  }
`;
